<template>
  <div>
    <div id="ambition">
      <div id="tabbar">
        <a class="tab" href="#ambition">{{ $t('aboutUs.ambition')}}</a>
        <a class="tab" href="#categories">{{ $t('aboutUs.categories')}}</a>
        <a class="tab" href="#founder">{{ $t('aboutUs.founder')}}</a>
        <a class="tab" href="#organizations">{{ $t('aboutUs.organizations')}}</a>
        <a class="tab" href="#media">{{ $t('aboutUs.media')}}</a>
      </div>
      <div id="title">{{ $t('aboutUs.ambition')}}</div>
      <div id="content">
        <div id="text-content">
          <p id="para1" v-html="$t('aboutUs.para1')" />
          <p id="para2" v-html="$t('aboutUs.para2')" />
          <p id="para3" v-html="$t('aboutUs.para3')" />
        </div>
        <div id="image-content">
          <div id="image1" />
          <div id="image2" />
        </div>
      </div>
    </div>

    <div id="categories" v-bind:class="{ collapsed: categoriesCollapsed }">
      <div id="title">
        <span class="desktop">{{ $t('aboutUs.categoriesTitle')}}</span>
        <span class="mobile" @click="categoriesTitleClicked">
          {{ $t('aboutUs.categoriesTitleMobile')}}
          <i class="fa fa-caret-up" aria-hidden="true" />
          <i class="fa fa-caret-down" aria-hidden="true" />
        </span>
      </div>

      <div class="collapsible">
        <div id="item1" class="item">
          <div class="image" />
          <div class="text">{{ $t('home.school')}}</div>
        </div>

        <div id="item2" class="item">
          <div class="image" />
          <div class="text">{{ $t('home.train')}}</div>
        </div>

        <div id="item3" class="item">
          <div class="image" />
          <div class="text">{{ $t('home.training')}}</div>
        </div>

        <div id="item4" class="item">
          <div class="image" />
          <div class="text">{{ $t('home.happyMonday')}}</div>
        </div>

        <div id="item5" class="item">
          <div class="image" />
          <div class="text">{{ $t('home.phone')}}</div>
        </div>

        <div id="item6" class="item">
          <div class="image" />
          <div class="text">{{ $t('home.drama')}}</div>
        </div>

        <div id="zoom" />
      </div>
    </div>

    <div id="founder" v-bind:class="{ collapsed: founderCollapsed }">
      <div id="title">
        <span class="desktop">{{ $t('aboutUs.founder')}}</span>
        <span class="mobile" @click="founderTitleClicked">
          {{ $t('aboutUs.founder')}}
          <i class="fa fa-caret-up" aria-hidden="true" />
          <i class="fa fa-caret-down" aria-hidden="true" />
        </span>
      </div>
      <div class="collapsible">
        <div id="founder-name">{{ $t('aboutUs.rickChow')}}</div>
        <div class="para">{{ $t('aboutUs.para4')}}</div>
        <div class="para">{{ $t('aboutUs.para5')}}</div>
        <div class="para">{{ $t('aboutUs.para6')}}</div>
        <div class="para">{{ $t('aboutUs.para7')}}</div>
        <div class="para">{{ $t('aboutUs.para8')}}</div>
        <div class="para">{{ $t('aboutUs.para9')}}</div>
      </div>
    </div>
    
    <div id="organizations" v-bind:class="{ collapsed: organizationsCollapsed }">
      <div id="title">
        <span class="desktop">{{ $t('aboutUs.organizations')}}</span>
        <span class="mobile" @click="organizationsTitleClicked">
          {{ $t('aboutUs.organizations')}}
          <i class="fa fa-caret-up" aria-hidden="true" />
          <i class="fa fa-caret-down" aria-hidden="true" />
        </span>
      </div>

      <div class="collapsible">
        <div id="sub-title">{{ $t('aboutUs.partners')}}</div>
        <div>
          <img :src="maLogo" class="partner-image" />
          <div class="partner-text">{{ $t('aboutUs.partnerMA') }}</div>
        </div>
        <div>
          <img :src="gzLogo" class="partner-image" />
          <div class="partner-text">{{ $t('aboutUs.partnerGZ') }}</div>
        </div>

        <div id="sub-title">{{ $t('aboutUs.organizationsTitle')}}</div>
        <div id="school">{{ $t('aboutUs.school')}}</div>

        <div id="school-list">
          <div>
            <div v-for="i in 11" class="org">
              ◆{{ $t(`aboutUs.school${i}`) }}
            </div>
          </div>
          <div>
            <div v-for="i in 11" class="org">
              ◆{{ $t(`aboutUs.school${i + 11}`) }}
            </div>
          </div>
        </div>

        <div id="entrepreneur">{{ $t('aboutUs.entrepreneur')}}</div>

        <div id="company-list">
          <div>
            <div v-for="i in 13" class="org">
              ◆{{ $t(`aboutUs.co${i}`) }}
            </div>
          </div>
          <div>
            <div v-for="i in 13" class="org">
              ◆{{ $t(`aboutUs.co${i + 13}`) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="media" v-bind:class="{ collapsed: mediaCollapsed }">
      <div id="title">
        <span class="desktop">{{ $t('aboutUs.media')}}</span>
        <span class="mobile" @click="mediaTitleClicked">
          {{ $t('aboutUs.media')}}
          <i class="fa fa-caret-up" aria-hidden="true" />
          <i class="fa fa-caret-down" aria-hidden="true" />
        </span>
      </div>

      <div class="clippings collapsible">
        <a :href="interview1" target="_blank" class="clipping" id="clipping1">
          <div class="inner">
            <div class="head">{{ $t('aboutUs.report1')}}</div>
            <div class="source">{{ $t('aboutUs.source1')}}</div>
            <div class="read-more">{{ $t('aboutUs.readClipping')}}</div>
            <div class="foreground" />
          </div>
        </a>

        <a :href="interview2" target="_blank" class="clipping" id="clipping2">
          <div class="inner">
            <div class="head">{{ $t('aboutUs.report2')}}</div>
            <div class="source">{{ $t('aboutUs.source2')}}</div>
            <div class="read-more">{{ $t('aboutUs.readClipping')}}</div>
            <div class="foreground" />
          </div>
        </a>

        <a :href="interview3" target="_blank" class="clipping" id="clipping3">
          <div class="inner">
            <div class="head">{{ $t('aboutUs.report3')}}</div>
            <div class="source">{{ $t('aboutUs.source3')}}</div>
            <div class="read-more">{{ $t('aboutUs.readClipping')}}</div>
            <div class="foreground" />
          </div>
        </a>

        <a :href="interview4" target="_blank" class="clipping" id="clipping4">
          <div class="inner">
            <div class="head">{{ $t('aboutUs.report4')}}</div>
            <div class="source">{{ $t('aboutUs.source4')}}</div>
            <div class="read-more">{{ $t('aboutUs.readClipping')}}</div>
            <div class="foreground" />
          </div>
        </a>

        <a class="radio" :href="interview5" target="_blank">
          <div class="head">{{ $t('aboutUs.report5')}}</div>
          <div class="read-more">{{ $t('aboutUs.listenProgram')}}</div>
        </a>

        <a :href="interview6" target="_blank" class="clipping" id="clipping6">
          <div class="inner">
            <div class="head">{{ $t('aboutUs.report6')}}</div>
            <div class="source">{{ $t('aboutUs.source6')}}</div>
            <div class="read-more">{{ $t('aboutUs.readClipping')}}</div>
            <div class="foreground" />
          </div>
        </a>

        <a class="radio" id="radio3" :href="interview7" target="_blank">
          <div class="head">{{ $t('aboutUs.report7')}}</div>
          <div class="read-more">{{ $t('aboutUs.listenProgram')}}</div>
        </a>

        <a :href="interview8" target="_blank" class="clipping" id="clipping1">
          <div class="inner">
            <div class="head">{{ $t('aboutUs.report8')}}</div>
            <div class="source">{{ $t('aboutUs.source8')}}</div>
            <div class="read-more">{{ $t('aboutUs.readClipping')}}</div>
            <div class="foreground" />
          </div>
        </a>

        <a :href="interview9" target="_blank" class="clipping" id="clipping2">
          <div class="inner">
            <div class="head">{{ $t('aboutUs.report9')}}</div>
            <div class="source">{{ $t('aboutUs.source9')}}</div>
            <div class="read-more">{{ $t('aboutUs.readClipping')}}</div>
            <div class="foreground" />
          </div>
        </a>

      </div>
    </div>
  </div>
</template>

<script>
import interview1 from '../../static/interviews/interview_1.jpg';
import interview2 from '../../static/interviews/interview_2.jpg';
import interview3 from '../../static/interviews/interview_3.jpg';
import interview4 from '../../static/interviews/interview_4.jpg';
import interview5 from '../../static/interviews/interview_5.mp3';
import interview7 from '../../static/interviews/interview_7.mp3';
import interview9 from '../../static/interviews/interview_9.pdf';

import maLogo from '../../static/logo-ma.jpeg';
import gzLogo from '../../static/logo-gz.jpeg';


export default {
  name: 'About',
  data() {
    return {
      categoriesCollapsed: true,
      founderCollapsed: true,
      organizationsCollapsed: true,
      mediaCollapsed: true,
      interview1,
      interview2,
      interview3,
      interview4,
      interview5,
      interview6: 'http://mp.weixin.qq.com/s/xuWYaluAe6LMp1jUN4AJeQ',
      interview7,
      interview8: 'http://www.xincunschool.com/show.asp?id=1593',
      maLogo,
      gzLogo,
      interview9,
    };
  },
  methods: {
    categoriesTitleClicked() {
      this.categoriesCollapsed = !this.categoriesCollapsed;
    },
    founderTitleClicked() {
      this.founderCollapsed = !this.founderCollapsed;
    },
    organizationsTitleClicked() {
      this.organizationsCollapsed = !this.organizationsCollapsed;
    },
    mediaTitleClicked() {
      this.mediaCollapsed = !this.mediaCollapsed;
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../styles/variables.sass"
      

  @media #{$mobile}
    #title
      .mobile
        line-height: 100px
        font-size: 24px !important
        cursor: pointer
        display: block

      .fa
        line-height: 95px
        font-size: 30px
        position: absolute
        right: 16px

    .fa-caret-down
      display: none

    .collapsed
      .collapsible
        display: none !important

      #title
        padding-top: 0 !important

      .fa-caret-up
        display: none

      .fa-caret-down
        display: inline-block
      
</style>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  #ambition
    margin: 30px auto
    width: 792px

    @media #{$desktop-small}
      width: 593px

    @media #{$mobile}
      width: 100%
      padding: 0 35px
    
    #tabbar
      display: flex
      justify-content: center
      .tab
        width: 128px
        border: 2px solid $macaroni-and-cheese
        border-radius: 2px
        font-size: 16px
        color: $macaroni-and-cheese
        line-height: 34px
        background-color: $ecru-white
        text-align: center
        margin-right: 12px
        cursor: pointer

      @media #{$mobile}
        display: none

    #title
      text-align: center
      font-size: 36px
      color: $froly
      margin: 30px 0
      @media #{$mobile}
        font-size: 24px

    #content
      display: flex

      #text-content
        #para1
          color: $fountain-blue

        #para2
          margin-top: 24px
          color: $emerald

        #para3
          margin-top: 24px
          color: $lavender

      #image-content
        margin-top: 14px
        #image1
          background-image: url('../../static/about-photo1.jpg')
        #image2
          background-image: url('../../static/about-photo2.jpg')
        #image1, #image2
          width: 264px
          height: 170px
          background-size: cover
          background-position: center
          border: 1px solid $silver
          
          margin-left: 50px
          margin-bottom: 10px

          @media #{$desktop-small}
            width: 211px
            height: 136px

        @media #{$mobile}
          display: none

</style>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  #categories
    height: 1116px
    background-image: url('../../static/bubble-background.png')
    background-size: cover
    background-position: center
    background-color: $aquamarine-blue
    position: relative

    @media #{$mobile}
      height: 1236px
      background-image: url('../../static/bubble-background-small.png')

    &.collapsed
      @media #{$mobile}
        background-image: none
        height: initial

    #title
      text-align: center
      padding-top: 100px
      color: $white
      font-size: 36px

      @media #{$mobile}
        font-size: 24px
        padding-top: 30px

    .item
      border: 4px solid $white
      position: absolute
      z-index: 2
      
      .text
        color: $white
        text-align: center
        margin-top: 12px
        font-size: 16px
        @media #{$mobile}
          margin-top: 8px
          font-size: 14px
      .image
        margin: 0 auto
        background-size: cover
        background-position: center

    #item1
      width: 180px
      height: 180px
      border-radius: 90px
      left: calc(20% - 90px)
      top: 15%

      @media #{$mobile}
        width: 250px
        height: 250px
        border-radius: 125px
        top: 62%
        left: 45%

      .image
        width: 103px
        height: 48px
        margin-top: 45px
        background-image: url('../../static/school-icon-white.png')

        @media #{$mobile}
          margin-top: 90px
          width: 74px
          height: 36px

    #item2
      width: 224px
      height: 224px
      border-radius: 112px
      left: calc(35% - 112px)
      top: 35%

      @media #{$mobile}
        width: 144px
        height: 144px
        top: 42%
        left: calc(65% - 72px)

      .image
        width: 118px
        height: 79px
        margin-top: 55px
        background-image: url('../../static/train-icon-white.png')
        
        @media #{$mobile}
          margin-top: 35px
          width: 64px
          height: 43px


    #item3
      width: 224px
      height: 224px
      border-radius: 112px
      left: calc(75% - 112px)
      top: 20%

      @media #{$mobile}
        width: 208px
        height: 208px
        top: 15%

      .image
        width: 114px
        height: 79px
        margin-top: 55px
        background-image: url('../../static/training-icon-white.png')

        @media #{$mobile}
          width: 83px
          height: 60px
        

    #item4
      width: 360px
      height: 360px
      border-radius: 360px
      left: calc(64% - 180px)
      top: 45%

      @media #{$mobile}
        width: 197px
        height: 197px
        top: 30%
        left: calc(28% - 100px)

      .image
        width: 92px
        height: 88px
        margin-top: 115px
        background-image: url('../../static/monday-icon-white.png')

        @media #{$mobile}
          margin-top: 55px
          width: 60px
          height: 60px

    #item5
      width: 240px
      height: 240px
      border-radius: 120px
      left: calc(22% - 120px)
      top: 70%

      @media #{$mobile}
        width: 200px
        height: 200px
        top: 80%
        left: calc(40% - 100px)

      .image
        width: 100px
        height: 80px
        margin-top: 55px
        background-image: url('../../static/phone-icon-white.png')

        @media #{$mobile}
          margin-top: 55px
          width: 60px
          height: 50px

    #item6
      width: 180px
      height: 180px
      border-radius: 90px
      left: calc(55% - 90px)
      top: 80%

      @media #{$mobile}
        width: 184px
        height: 184px
        left: calc(30% - 92px)
        top: 52%

      .image
        width: 108px
        height: 78px
        margin-top: 28px
        background-image: url('../../static/drama-icon-white.png')
        
        @media #{$mobile}
          margin-top: 45px
          width: 69px
          height: 52px

    #zoom
      position: absolute
      width: 342px
      height: 326px
      background-size: cover
      background-position: center
      background-repeat: no-repeat
      background-image: url('../../static/zoom-icon.png')
      top: 68%
      left: calc(88% - 171px)
      z-index: 1

      @media #{$mobile}
        -moz-transform: scaleX(-1)
        -o-transform: scaleX(-1)
        -webkit-transform: scaleX(-1)
        transform: scaleX(-1)
        filter: FlipH
        -ms-filter: "FlipH"
        top: 10%
        left: 0
        width: 268px
        height: 255px

</style>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  #founder
    background-color: $black-squeeze
    padding: 50px 56px
    @media #{$mobile}
      padding: 20px 25px
      &.collapsed
        padding: 0

    #title
      font-size: 36px
      text-align: center
      color: $downy
      margin-bottom: 50px
      @media #{$mobile}
        margin-bottom: 0

    #founder-name
      font-size: 30px
      color: $opal
      margin-bottom: 20px
      @media #{$mobile}
        font-size: 20px
        margin-bottom: 10px

    .para
      color: $nevada
      font-size: 14px
      margin-bottom: 20px
</style>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  #organizations
    background-color: $koromiko
    padding: 60px 100px

    @media #{$mobile}
      padding: 45px 15px
      padding-top: 20px

      &.collapsed
        padding: 0

    #title
      font-size: 36px
      color: $white
      text-align: center
      @media #{$mobile}
        font-size: 24px

    #sub-title
      font-size: 24px
      color: $texas
      margin-top: 60px
      @media #{$mobile}
        font-size: 20px
        margin-top: 30px

    .partner-image
      width: 380px
      margin-top: 20px

    .partner-text
      font-size: 18px
      margin-top: 10px
      color: white
      @media #{$mobile}
        font-size: 14px

    #school, #entrepreneur
      font-size: 20px
      color: $texas
      margin-bottom: 10px

    #school
      margin-top: 20px
      @media #{$mobile}
        margin-top: 12px

    #entrepreneur
      margin-top: 30px

    #school-list, #company-list
      display: flex
      flex-wrap: wrap

      .org
        color: $white
        font-size: 18px
        @media #{$desktop}
          width: 430px
        @media #{$mobile}
          font-size: 14px

</style>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  #media
    background-color: $ecru-white
    padding: 70px 40px
    @media #{$mobile}
      padding: 50px 30px
      padding-top: 20px

      &.collapsed
        padding: 0
        #title
          margin-bottom: 0

    #title
      color: $koromiko
      font-size: 36px
      text-align: center
      margin-bottom: 25px
      @media #{$mobile}
        font-size: 24px
        margin-bottom: 10px

    .clippings
      display: flex
      flex-wrap: wrap
      justify-content: center

    .clipping
      width: 307px
      height: 239px
      background-size: contain
      background-position: center
      background-repeat: no-repeat
      background-image: url('../../static/newspaper-back.png')
      position: relative
      margin: 35px 6px 0 6px

      .inner
        padding: 12px 20px
        position: absolute
        background-color: $white
        top: 65px
        left: 42px
        right: 0
        bottom: 0
        border-width: 4px
        border-style: solid

      .head
        font-size: 24px
        line-height: 34px
        margin-left: -10px
        white-space: nowrap
        @media #{$mobile}
          font-size: 18px

      .source
        font-size: 18px
        @media #{$mobile}
          font-size: 16px

      .read-more
        margin-top: 18px
        font-size: 14px
        display: inline-block
        border-bottom-style: solid
        border-bottom-width: 2px

      .foreground
        position: absolute
        background-size: contain
        background-position: center
        background-repeat: no-repeat
        background-image: url('../../static/newspaper-front.png')
        width: 223px
        height: 82px
        bottom: 8px
        right: 12px

      @media #{$mobile}
        margin-top: 25px
        width: 248px
        .inner
          left: 10px
        .foreground
          width: 199px

    .radio
      width: 307px
      height: 239px
      margin: 35px 6px 0 6px
      background-size: 274px 196px 
      background-position-x: right
      background-position-y: bottom
      background-repeat: no-repeat
      background-image: url('../../static/radio.png')
      padding-top: 125px
      padding-left: 58px

      &#radio2
        background-image: url('../../static/radio2.png')
        color: #A0C18A

      &#radio3
        background-image: url('../../static/radio3.png')
        color: #4EC2C6

      .head
        font-size: 24px
        margin-left: -10px
        white-space: nowrap

        @media #{$mobile}
          font-size: 18px

      .read-more
        margin-top: 40px
        font-size: 14px
        display: inline-block
        border-bottom-style: solid
        border-bottom-width: 2px

      @media #{$mobile}
        width: 248px
        height: 200px
        padding-top: 94px
        padding-left: 33px
        background-size: contain

    #clipping1
      color: $sea-pink

    #clipping2
      color: $olivine

    #clipping3
      color: $tan-hide

    #clipping4
      color: $fountain-blue

    #clipping6
      color: $olivine

    .radio
      color: $sea-pink

</style>

<style lang="sass">
  @import "../styles/variables.sass"

  #ambition
    #para1
      #t1
        color: $ecstasy
        font-size: 24px
      #t2
        color: $gulf-stream
        font-size: 24px
      #t3
        color: $froly
        font-size: 24px
      #t4
        color: $olivine
        font-size: 24px

</style>



// WEBPACK FOOTER //
// src/components/About.vue